import axios from "axios"
import { useEffect, useState } from "react"
import { Fade } from "react-awesome-reveal"
import PageLoader from "../../components/global/loader/PageLoader"
import { InternalBanner } from "../../components/internals/InternalBanner"
import './styles.scss';

export const CaseResults = () => {
    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        fetchPageContent();
    }, []);

    const fetchPageContent = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=case-results`);
            setPageContent(data);
            if (data?.yoast_title?.length > 0) {
                document.title = data?.yoast_title;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title}` : "Case Results - Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
            }
            if (document.querySelector('#wp-admin-bar-edit a')) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    return <Fade delay={1}>
        <main id="main" className="internal-page">
            {
                !isFetchingPageData && <>                
                    <InternalBanner page={pageContent?.page} />
                    <section id="case-section" className="home-section">
                        <div className='section-case-wrapper'>
                            <div className='container'>
                                <div className="settlements">
                                    {
                                        pageContent?.fields?.verdict_and_settlement_repeater?.map((it, index) => <div className="section-case-wrapper" key={index}>
                                            <h2>{it?.block_title}</h2>
                                            <div className="case-repeater">
                                                {
                                                    it?.block_repeater?.map((_it, _index)=><div className='block-case-item' key={_index}>
                                                    <div className='block-heading'>
                                                        <span className='icon' dangerouslySetInnerHTML={{__html: _it?.block_icon}}></span>
                                                        <span className='title'>
                                                            { _it?.block_title }
                                                        </span>
                                                    </div>
                                                    <div className='block-details'>
                                                        <span className='block-type'>{ _it?.block_case_type }</span>
                                                        <span className='block-value'>{ _it?.block_amount }</span>
                                                        <span className='block-content'>{ _it?.block_details }</span>
                                                    </div>
                                                </div>)
                                                }
                                            </div>
                                        </div>)
                                    }
                                </div>

                            </div>
                        </div>
                    </section>
                </>
            }

            {
                isFetchingPageData && <PageLoader />
            }
        </main>
    </Fade>
}